import styled from '@emotion/styled';
import * as React from 'react';
import { colors, fontWeight } from '~/styles/constants';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  padding: 0 24px;
`;

const Title = styled('h3')`
  font-size: 11px;
  font-weight: ${fontWeight.medium};
  padding-right: 8px;
  color: ${colors.loblolly};
`;

const Line = styled('div')`
  border: 1px solid #efefef;
  flex: 1;
`;

const FAIcon = styled('i')`
  padding-left: 1px;
  padding-top: 2px;
  cursor: pointer;
  color: ${colors.primaryAlternative};
`;

const IconContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  width: 20px;
  height: 20px;
  line-height: 22px;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgba(214, 214, 214);
`;

export type SectionTitleProps = {
  onAddPackageClick?: () => void;
  children: React.ReactNode;
};

const SectionTitle = (props: SectionTitleProps) => {
  return (
    <Wrapper>
      <Title>{props.children}</Title>
      <Line />
      {props.onAddPackageClick && (
        <IconContainer>
          <FAIcon className="fa fa-plus" onClick={props.onAddPackageClick} />
        </IconContainer>
      )}
    </Wrapper>
  );
};

export default SectionTitle;
